// client/src/components/marketer/MarketerBizHeader.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearMarketerCache } from '../../utils/marketerProjectCache';
import { clearResultCache } from '../../utils/marketerResultCache';
import { clearCPSCache } from '../../utils/marketerCPSCache';
import { usePoints } from '../../contexts/PointContext';
import '../../styles/marketer/MarketerHeader.css'; // CSS import 추가

const API_URL = process.env.REACT_APP_API_URL;

function MarketerBizHeader({ onMenuClick }) {
  const nav = useNavigate();
  const { points, loading, isRefreshing } = usePoints();

	const goHome = () => nav('/marketer/mybiz');

	const logout = async () => {
		try {
			await fetch(`${API_URL}/api/user/logout`, { method: 'POST', credentials: 'include' });
		} catch {}
		
		// ✅ 1. 캐시 초기화 (window.__ME__ 삭제 전에!)
		const uid = window.__ME__?.id;
		clearMarketerCache(uid);
		clearResultCache(uid);
		clearCPSCache(uid);
		
		// ✅ 2. sessionStorage 완전 초기화
		try {
			const keys = Object.keys(sessionStorage);
			keys.forEach(key => {
				if (key.startsWith('MARKETER_PROJECT_') || 
				    key.startsWith('MARKETER_RESULT_') ||
				    key.startsWith('MARKETER_CPS_') ||
				    key.startsWith('INF_') ||
				    key.startsWith('user_points_cache_') ||
				    key.startsWith('mrk_') ||
				    key === 'current_user_key' || 
				    key === 'current_user_role') {
					sessionStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 3. localStorage 광고주 관련 캐시 초기화
		try {
			const lsKeys = Object.keys(localStorage);
			lsKeys.forEach(key => {
				if (key.startsWith('mrk_') || key.startsWith('marketer_')) {
					localStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 4. window.__ME__ 완전히 삭제
		if (window.__ME__) {
			delete window.__ME__;
		}
		
		// ✅ 5. 페이지 새로고침으로 완전 초기화
		window.location.href = '/';
	};

	return (
		<header className="marketer-header">
			<div className="marketer-header__left">
				{onMenuClick && (
					<button className="marketer-header__menu-button" onClick={onMenuClick} aria-label="메뉴 열기">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" width="22" height="22">
							<path d="M4 7h16M4 12h16M4 17h16" />
						</svg>
					</button>
				)}
				<button className="marketer-header__logo-button" onClick={goHome} aria-label="광고주 홈으로">
					<img
						src="/images/logo.svg"
						alt="셀프애드"
						className="marketer-header__logo"
					/>
				</button>
				<span className="marketer-header__role-tag">광고주 (Advertiser)</span>
			</div>

		<div className="marketer-header__right">
			{/* 포인트 표시 */}
			<div className={`marketer-header__points ${loading ? 'marketer-header__points--loading' : ''} ${isRefreshing ? 'marketer-header__points--refreshing' : ''}`}>
				보유 (Balance) <b>{loading ? '...' : points.toLocaleString()}</b>P
			</div>

			<button className="marketer-header__logout" onClick={logout}>로그아웃 (Log out)</button>

			<span className="marketer-header__avatar" aria-hidden="true">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="18" height="18">
					<circle cx="12" cy="8" r="4" />
					<path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" />
				</svg>
			</span>
		</div>
		</header>
	);
}

export default MarketerBizHeader;